<script>
import Accordion from '../../../Accordion.vue'
import AccordionItem from '../../../AccordionItem.vue'
import LoadingCvPersonalDetails from './PersonalDetails.vue'
import LoadingCvAims from './Aims.vue'
import moment from 'moment'
import IfactFormUploadModal from '../IfactFormUploadModal.vue'
export default {
    components: {
        Accordion,
        AccordionItem,
        LoadingCvPersonalDetails,
        LoadingCvAims,
        IfactFormUploadModal,
    },
    props: {
        jobApplication: {
            type: Object|Array,
            required: true
        },
        divClass: {
            type: String,
            default: 'small-12 medium-5'
        },
        module: {
            type: Object|Array,
            required: true
        },
        traitStatementsByCluster: {
            type: Object|Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        failedJobApplications: {
            type: Object|Array,
            required: false
        },
    },
    data() {
        return {
            comms: {
                candidate_reminder: {
                    title: 'Candidate Reminder',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                recycle: {
                    title: 'Recycle',
                    sms: true,
                    email: true,
                    whatsapp: false
                },

                killer_question_pass: {
                    title: 'Killer Question Pass',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                killer_question_failed: {
                    title: 'Killer Question Failed',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                voice_assessment_whatsapp_1: {
                    title: 'Voice Assessment WhatsApp 1',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_2: {
                    title: 'Voice Assessment WhatsApp 2',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_3: {
                    title: 'Voice Assessment WhatsApp 3',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_4: {
                    title: 'Voice Assessment WhatsApp 4',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_5: {
                    title: 'Voice Assessment WhatsApp 5',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_6: {
                    title: 'Voice Assessment WhatsApp 6',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_7: {
                    title: 'Voice Assessment WhatsApp 7',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                voice_assessment_whatsapp_8: {
                    title: 'Voice Assessment WhatsApp 8',
                    sms: false,
                    email: false,
                    whatsapp: true
                },
                language_proficiency_successful: {
                    title: 'Language Proficiency Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                language_proficiency_unsuccessful: {
                    title: 'Language Proficiency Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                language_proficiency_resubmission: {
                    title: 'Language Proficiency Resubmission Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                telephonic_screening_request: {
                    title: 'Telephonic Screening Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                telephonic_screening_successful: {
                    title: 'Telephonic Screening Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                telephonic_screening_unsuccessful: {
                    title: 'Telephonic Screening Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                first_interview_request: {
                    title: 'First Interview Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                first_interview_successful: {
                    title: 'First Interview Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                first_interview_unsuccessful: {
                    title: 'First Interview Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                skills_assessment_successful: {
                    title: 'Skills Assessment Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                skills_assessment_unsuccessful: {
                    title: 'Skills Assessment Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                panel_interview_request: {
                    title: 'Panel Interview Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                panel_interview_successful: {
                    title: 'Panel Interview Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                panel_interview_unsuccessful: {
                    title: 'Panel Interview Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                background_verification_successful: {
                    title: 'Background Verification Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                background_verification_unsuccessful: {
                    title: 'Background Verification Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                loading_offer: {
                    title: 'Loading Offer Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                loading_offer_unsuccessful: {
                    title: 'Loading Offer Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                loading_offer_successful: {
                    title: 'Loading Offer Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                start_confirmation: {
                    title: 'Start Confirmation',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                onboarding_feedback_request: {
                    title: 'Onboarding Feedback Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                onboarding_successful: {
                    title: 'Onboarding Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                onboarding_unsuccessful: {
                    title: 'Onboarding Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                first_day_feedback_request: {
                    title: 'First Day Feedback Request',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                start_successful: {
                    title: 'Start Successful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                start_unsuccessful: {
                    title: 'Start Unsuccessful',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                finish_loading_your_cv: {
                    title: 'Finish loading your CV',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                finish_your_aims_modules: {
                    title: 'Finish your AIMS modules',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                update_your_education: {
                    title: 'Update your education',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                update_your_killer_questions: {
                    title: 'Complete your Job Questionnaire',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                finish_your_language_proficiency_recordings: {
                    title: 'Finish your language proficiency recordings',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                finish_your_skills_assessment: {
                    title: 'Finish your skills assessment',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                give_consent: {
                    title: 'Give consent',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
                upload_your_documents: {
                    title: 'Upload your documents',
                    sms: true,
                    email: true,
                    whatsapp: false
                },
            }
        };
    },
    methods: {
        convertDate(date, format = 'YYYY-MM-DD hh:mm') {
            return moment(date).format(format)
        },
        s3Url(path) {
            const baseUrl = 'https://mycalling-uploads.s3.eu-west-1.amazonaws.com/';
            const relativePath = path.substring(path.indexOf('/uploads/documents'));
            return baseUrl + relativePath;
        },
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
    }
}
</script>

<template>
    <Accordion>
        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Personal Details</strong> <p>{{ jobApplication.user.personal_details_percent_complete }}% <i v-if="jobApplication.user.personal_details_percent_complete == 100" class="fa fa-check" style="color: #6ABC45"></i></p> 
            </template>
            <template slot="accordion-content">
                <LoadingCvPersonalDetails :job-application="jobApplication" :div-class="divClass" />
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>CV Details</strong> <p>{{ jobApplication.user.cv_details_percent_complete }}% <i v-if="jobApplication.user.cv_details_percent_complete == 100" class="fa fa-check" style="color: #6ABC45"></i></p> 
            </template>
            <template slot="accordion-content">
                <div v-if="jobApplication.user.user_detail !== null" class="grid-x grid-padding-x">
                    <div class="cell small-12">
                        <h3>Languages</h3>
                    </div>
                    <div v-if="jobApplication.user.user_detail !==null && jobApplication.user.user_detail.language_proficiencies !== undefined">
                        <div class="cell small-12"
                            v-for="(cvLanguage, index) in jobApplication.user.user_detail.language_proficiencies"
                            :key="'lang' + index">
                            <div class="grid-x grid-padding-x">
                                <div class="form-control cell small-6">
                                    <label>Language</label>
                                    <input type="text" disabled :value="cvLanguage.language.title" />
                                </div>
                                <div class="form-control cell small-6">
                                    <label>Fluency</label>
                                    <input type="text" disabled :value="cvLanguage.fluency" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cell small-12 mt-5">
                        <h3>Education</h3>
                    </div>
                    <div v-if="jobApplication.user.user_detail !== null && jobApplication.user.user_detail.qualifications !== undefined">
                        <div class="cell small-12"
                            v-for="(cvEducation, index) in jobApplication.user.user_detail.qualifications"
                            :key="'edu' + index">
                            <div class="grid-x grid-padding-x">
                                <div class="form-control cell small-12">
                                    <label>Highest Level of Education</label>
                                    <input type="text" disabled :value="cvEducation.qualification_level.title" />
                                </div>
                                <div class="form-control cell small-12">
                                    <label>Type of Institution</label>
                                    <input type="text" disabled :value="cvEducation.institution_type ? cvEducation.institution_type.type : ''" />
                                </div>
                                <div class="form-control cell small-12">
                                    <label>Institution</label>
                                    <input type="text" disabled :value="cvEducation.institution_title" />
                                </div>
                                <div class="form-control cell small-12">
                                    <label>Field of Study</label>
                                    <input type="text" disabled :value="(cvEducation.subjects[0])? cvEducation.subjects[0].title : ''" />
                                </div>
                                <div class="form-control cell small-12">
                                    <label>Course Studied</label>
                                    <input type="text" disabled :value="cvEducation.course_studied" />
                                </div>
                                <div class="form-control cell small-12" style="padding-bottom: 12px">
                                    <label>Documents</label>
                                    <ul>
                                        <li v-for="(qualification_document, idx) in cvEducation.qualification_documents" :key="idx">
                                            <a :href="qualification_document.path_cdn">{{ qualification_document.path_cdn }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cell small-12 mt-5">
                        <h3>Work Experience</h3>
                    </div>
                    <div class="cell small-11 ml-20">
                        <Accordion>
                            <AccordionItem
                                v-for="(cvWorkExp, index) in jobApplication.user.user_detail.user_detail_jobs"
                                        :key="'work' + index"
                                >
                                <template slot="accordion-trigger">
                                    <strong>{{ cvWorkExp.employer }} ({{ convertDate(cvWorkExp.start_date, 'MMMM YYYY') }} - {{ convertDate(cvWorkExp.end_date, 'MMMM YYYY') }})</strong>
                                </template>
                                <template slot="accordion-content">
                                    <div class="cell small-12">
                                        <div class="grid-x grid-padding-x" v-if="!cvWorkExp.is_gap">
                                            <div class="form-control cell small-12">
                                                <label>Company/Institution Name</label>
                                                <input type="text" disabled :value="cvWorkExp.employer" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Industry</label>
                                                <input type="text" disabled :value="`(cvWorkExp.industry !== undefined) ? cvWorkExp.industry.title : ''`" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Role</label>
                                                <input type="text" disabled :value="(cvWorkExp.role !== null) ? cvWorkExp.role.title : ''" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Responsibilities</label>
                                                <input type="text" disabled :value="cvWorkExp.responsibilities" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Industry specific qualifications</label>
                                                <input type="text" disabled :value="cvWorkExp.industry_qualifications" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Start Date</label>
                                                <input type="text" disabled :value="cvWorkExp.start_date" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>End Date</label>
                                                <input type="text" disabled :value="cvWorkExp.end_date" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <label>Reason for leaving</label>
                                                <input v-if="cvWorkExp.reason_for_leaving !== 'other'" type="text" disabled :value="cvWorkExp.reason_for_leaving" />
                                                <input v-else type="text" disabled :value="cvWorkExp.other_reason_for_leaving" />
                                            </div>
                                            <div class="form-control cell small-12">
                                                <hr style="max-width: unset;"/>
                                                <form method="post">
                                                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                                                    <label>Recruiter's Note</label>
                                                    <input type="text" name="recruiter_notes" :value="cvWorkExp.recruiter_notes" />
                                                    <input type="hidden" name="id" :value="cvWorkExp.id" />

                                                    <div>
                                                        <button class="button" type="submit" name="work_experience_recruiter_notes" value="work_experience_recruiter_notes">Submit</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </AccordionItem>
                        </Accordion>
                    </div>
                </div>
                <div v-else>
                    <p>
                        Details info for this user is not available <br/>
                    </p>
                </div>
            </template>
        </AccordionItem>
        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Printed CV</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <iframe :src="`${jobApplication.user.cv_url}`" width="100%" height="1000px"></iframe>
                </div>
            </template>
        </AccordionItem>
        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Personal CV</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <iframe v-if="jobApplication.user.personal_cv_url" :src="`${jobApplication.user.personal_cv_url}`" width="100%" height="1000px"></iframe>
                    <div v-else>
                        <p>
                            No Personal CV Available
                        </p>
                    </div>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Consent</strong> <small>{{ jobApplication.user.agree_to_marketing ? 'Yes' : 'No' }}</small>
            </template>
            <template slot="accordion-content">
                {{ jobApplication.user.agree_to_marketing ? 'Yes' : 'No' }}
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>AIMS</strong>
            </template>
            <template slot="accordion-content">
                <LoadingCvAims :user-detail="jobApplication.user.user_detail" :module="module"
                    :trait-statements-by-cluster="traitStatementsByCluster" />
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Ifacts Form</strong>
            </template>
            <template slot="accordion-content">
                <div v-if="jobApplication.ifact_form" class="ifact-loading-cv">
                    <div class="grid-x grid-padding-x">
                        <div v-if="jobApplication.ifact_form.document_url" class="col auto form">
                            Upload Manually.
                        </div>
                        <div v-else class="cell auto form">
                            I, the undersigned (full name) <div class="form-label">{{ jobApplication.ifact_form.first_name }}</div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(surename)<div class="form-label">{{ jobApplication.ifact_form.surename }}</div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(maiden name)<div class="form-label">{{ jobApplication.ifact_form.maiden_name }}</div><br />
                            ID Number&nbsp;<div class="form-label">{{ jobApplication.ifact_form.id_number }}</div> (If not available, date of birth & passport number)<br />
                            Have you ever been convicted of an offence?&nbsp;<div class="form-label">{{ jobApplication.ifact_form.is_ever_convicted ? 'Yes' : 'No' }}</div><br />
                            If so state the place, date and sentence.&nbsp;<div class="form-label" style="width: auto !important">{{ jobApplication.ifact_form.conviction_details }}</div><br />
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x mt-3">
                        <div v-if="!jobApplication.ifact_form.document_url" class="col auto form">
                            <a :href="`/recruiter/active-requisitions/ifact-form/${jobApplication.id}`" target="_blank">View Full Form</a> |
                            <a :href="`/candidate/ifact-form/download/${jobApplication.id}.pdf`" target="_blank">Download Form</a> | Last modified: {{ convertDate(jobApplication.ifact_form.modified) }}
                        </div>
                        <div v-else class="cell auto form ifact-form-upload">
                            <div class="grid-x grid-padding-x align-items-center">
                                <div class="cell shrink">
                                    <ifact-form-upload-modal
                                        ref="uploadIfactForm"
                                        :csrf-token="csrfToken"
                                        :job-application="jobApplication"
                                        button-text="Reupload"
                                    ></ifact-form-upload-modal>
                                </div>
                                <div class="cell shrink">
                                    <a class="button primary" :href="`${jobApplication.ifact_form.document_url_cdn}`" target="_blank">Download Form</a>
                                </div>
                                <div class="cell shrink">
                                    Uploaded: {{ convertDate(jobApplication.ifact_form.modified) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p>
                        Not Available <br/>
                        <ifact-form-upload-modal
                            ref="uploadIfactForm"
                            :csrf-token="csrfToken"
                            :job-application="jobApplication"
                            button-text="Upload Manually"
                        ></ifact-form-upload-modal>
                    </p>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Introduction</strong>
                <small v-if="jobApplication.user.introduce_yourself_percent_complete !== 100">
                    Not Added
                </small>
            </template>
            <template slot="accordion-content">
                <div v-if="jobApplication.user.introduce_yourself_percent_complete !== 100">N/A</div>

                <div v-if="jobApplication.user.video_path" class="mb-4">
                    <label>Video</label>
                    <a v-if="jobApplication.user.video_path" target="_blank"
                        :href="`${jobApplication.user.video_path_cdn}`">{{
                                jobApplication.user.video_path_cdn
                        }}</a>
                </div>

                <div v-if="jobApplication.user.audio_path">
                    <label>Audio</label>
                    <a v-if="jobApplication.user.audio_path" target="_blank"
                        :href="`${jobApplication.user.audio_path_cdn}`">{{
                                jobApplication.user.audio_path_cdn
                        }}</a>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <strong>Bio</strong>
            <template slot="accordion-trigger" v-if="jobApplication.user.user_detail !== null">
                <small v-if="jobApplication.user.user_detail.user_detail_profile_question_answers.length == 0">
                    Not Added
                </small>
            </template>
            <template slot="accordion-content">
                Bio...
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Baseline Score</strong>
                <small v-if="jobApplication.user.baseline_score === null">
                    Not Available
                </small>
            </template>
            <template slot="accordion-content">
                <div class="grid-x grid-padding-x">
                    <div class="form-control cell small-12">
                        <h2  v-if="jobApplication.user.baseline_score !== null">SCORE: {{ jobApplication.user.baseline_score }}</h2>
                    </div>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Language match</strong>
            </template>
            <template slot="accordion-content">
                <div class="grid-x grid-padding-x">
                    <div class="form-control cell small-12">
                        <div class="cell small-12">
                            <h3>Required Languages</h3>
                        </div>

                        <div class="cell small-12"
                            v-for="(reqLanguage, index) in jobApplication.job.requisition.person_specification.person_specification_languages"
                            :key="'lang' + index">
                            <div class="grid-x grid-padding-x">
                                <div class="form-control cell small-12">
                                    <label>Language</label>
                                    <input type="text" disabled :value="reqLanguage.language.title" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-control cell small-12" v-if="jobApplication.user.user_detail !== null && jobApplication.user.user_detail.language_proficiencies !== undefined">
                        <div class="cell small-12">
                            <h3>Candidate Languages</h3>
                        </div>

                        <div class="cell small-12"
                            v-for="(cvLanguage, index) in jobApplication.user.user_detail.language_proficiencies"
                            :key="'lang' + index">
                            <div class="grid-x grid-padding-x">
                                <div class="form-control cell small-6">
                                    <label>Language</label>
                                    <input type="text" disabled :value="(cvLanguage.language.title) ? cvLanguage.language.title : ''" />
                                </div>
                                <div class="form-control cell small-6">
                                    <label>Fluency</label>
                                    <input type="text" disabled :value="cvLanguage.fluency" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </AccordionItem>
        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Important Recruiter Notes On Candidate</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <div class="grid-x grid-padding-x">
                        <div class="form-control cell small-12">
                            <h3>Notes</h3>
                            <ol>
                                <li v-for="failedJobApplication in failedJobApplications" :key="failedJobApplication.id">
                                    <span v-for="applicationAction in failedJobApplication.job_application_actions" :key="applicationAction.id">
                                        {{ applicationAction.failed_message }}
                                    </span>
                                </li>
                            </ol>
                            <ol>
                                <li v-for="note in jobApplication.user.notes" :key="note">
                                    {{ note.message }}
                                    <ul>
                                        <li v-for="upload in note.uploads">
                                            <a :href="`https://res.cloudinary.com/ddznwy1te/image/upload/c_scale,dpr_auto,fl_attachment,q_auto:eco,w_auto/v1/${upload.upload}`"
                                               :download="upload.file_name"
                                                target="_blank">
                                                {{ upload.upload }}
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Comms Templates</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <div class="grid-x grid-padding-x">
                        <div class="form-control cell small-12">
                            <ol>
                                <li v-for="(comm, index) in comms" style="margin-top:10px" :key="`comms${index}`">
                                    {{ comm.title }}:<br/>
                                    <a v-if="comm.email" target="blank" :href="`/recruiter/active-requisitions/system-comms/${index}/${jobApplication.id}/email`" style="margin-right:20px">Email</a>

                                    <a v-if="comm.sms" target="blank" :href="`/recruiter/active-requisitions/system-comms/${index}/${jobApplication.id}/sms`" style="margin-right:20px">SMS</a>

                                    <a v-if="comm.whatsapp" target="blank" :href="`/recruiter/active-requisitions/system-comms/${index}/${jobApplication.id}/sms`">Whatsapp</a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Candidate Communications</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <div class="grid-x grid-padding-x">
                        <div class="form-control cell small-12">
                            <table class="unstriped" v-if="jobApplication.job_application_communications">
                                <thead>
                                    <tr>
                                        <th>Subject</th>
                                        <th>Type</th>
                                        <th>Recipient</th>
                                        <th>Date Sent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="comm in jobApplication.job_application_communications" :key="`commcandidate${comm.id}`">
                                        <td>
                                            <a target="blank" :href="`/recruiter/active-requisitions/communications-log/${comm.id}`">
                                                {{ comm.subject }}
                                            </a>
                                        </td>
                                        <td>{{ comm.type }}</td>
                                        <td>{{ comm.recipient }}</td>
                                        <td>{{ convertDate(comm.created) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
        </AccordionItem>

        <AccordionItem>
            <template slot="accordion-trigger">
                <strong>Additional Documents</strong>
            </template>
            <template slot="accordion-content">
                <div class="cell small-12">
                    <div class="grid-x grid-padding-x">
                        <div class="form-control cell small-12">
                            <table class="unstriped" v-if="jobApplication.user.user_documents">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Document</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(doc, index) in jobApplication.user.user_documents" :key="`doc-${doc.id}-${index}`">
                                        <td>
                                            {{ doc.title }}
                                        </td>
                                        <td>
                                            <a target="blank" :href="s3Url(doc.path)">
                                                <i class="fa fa-eye"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
        </AccordionItem>
    </Accordion>
</template>